import { QueryBuilderTokenType } from '../../../../../../types';

const tokenIds = new WeakMap<QueryBuilderTokenType, string>();
let nextTokenId = 0;

export const getTokenId = (token: QueryBuilderTokenType): string => {
  const existingId = tokenIds.get(token);

  if (existingId !== undefined) {
    return existingId;
  }

  const id = `pill-${nextTokenId++}`;
  tokenIds.set(token, id);

  return id;
};
